import React from 'react';

/**
 * Rastor AI Logo — stylized arrow/compass mark
 * Matches the generated brand icon (directional arrow in emerald gradient)
 */
const RastorLogo = ({ size = 20, className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <defs>
            <linearGradient id="rastor-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#10B981" />
                <stop offset="100%" stopColor="#14B8A6" />
            </linearGradient>
        </defs>
        {/* Arrow/compass shape pointing up-right — direction & navigation */}
        <path
            d="M4 20L12 4L20 12L12 14L14 20L10 16L4 20Z"
            fill="url(#rastor-gradient)"
            fillRule="evenodd"
        />
        {/* Inner detail — small accent */}
        <path
            d="M12 10L15 12L12 13L12 10Z"
            fill="#08090c"
            opacity="0.6"
        />
    </svg>
);

export default RastorLogo;
